var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree-page',{attrs:{"path":"/","ref-type":_vm.refType}})
}
var staticRenderFns = []

export { render, staticRenderFns }